import { Injectable, inject } from '@angular/core';

import { TagManagerService, TimerService, WINDOW } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { RUN_AFTER_LCP_TOKEN } from './run-after-lcp.token';
import { TrackingConfig } from './tracking.client-config';

@Injectable({ providedIn: 'root' })
export class GtmService {
    readonly #window = inject(WINDOW);
    private readonly tagManagerService = inject(TagManagerService);
    private readonly timerService = inject(TimerService);
    private readonly gtmConfig = inject(TrackingConfig);
    private readonly runAfterLcpToken = inject(RUN_AFTER_LCP_TOKEN);

    async renderGTMTag() {
        await firstValueFrom(this.gtmConfig.whenReady);
        if (this.gtmConfig?.enableGTM) {
            if (this.#window.partytown) {
                this.loadGTM();
            } else {
                this.runAfterLcpToken.runAfterLcp(() => {
                    this.timerService.scheduleIdleCallback(() => this.loadGTM(), this.gtmConfig.delayGTM);
                });
            }
        }
    }

    private async loadGTM() {
        await firstValueFrom(this.tagManagerService.whenReady);
        this.tagManagerService.loadPartyTownGTM();
    }
}
